const SOLID_COLOR_SET = ["#e65300", "#ff7702"];
const DESKTOP_ACCORDION = [
  {
    type: "Details",
    text: "DETAILS",
    keyToBeChecked: "story",
    isShown: true,
  },
  {
    type: "Features",
    text: "FEATURES",
    keyToBeChecked: "finerDetails.notes",
    isShown: true,
  },
  {
    type: "Specification",
    text: "SPECIFICATION",
    keyToBeChecked: "finerDetails.specs",
    isShown: true,
  },
  {
    type: "CareUsage",
    text: "CARE USAGE",
    keyToBeChecked: "finerDetails.compositionAndCare",
    isShown: true,
  },
  {
    type: "Warranty",
    text: "WARRANTY",
    keyToBeChecked: "warranty",
    isShown: true,
  },
];

// {
//   type: "Returns",
//   text: "RETURNS & EXCHANGES",
//   keyToBeChecked: "returnable",
//   isShown: true,
// },

const MOBILE_ACCORDION = [
  {
    type: "Details",
    text: "DETAILS",
    keyToBeChecked: "story",
    isShown: true,
    isOpen: false,
  },
  {
    type: "Features",
    text: "FEATURES",
    keyToBeChecked: "finerDetails.notes",
    isShown: true,
    isOpen: false,
  },
  {
    type: "Specification",
    text: "SPECIFICATION",
    keyToBeChecked: "finerDetails.specs",
    isShown: true,
    isOpen: false,
  },
  {
    type: "CareUsage",
    text: "CARE USAGE",
    keyToBeChecked: "finerDetails.compositionAndCare",
    isShown: true,
  },
  {
    type: "Warranty",
    text: "WARRANTY",
    keyToBeChecked: "warranty",
    isShown: true,
  },
];

// {
//   type: "Returns",
//   text: "RETURNS & EXCHANGES",
//   keyToBeChecked: "returnable",
//   isShown: true,
//   isOpen: false,
// },
const COLOR_TEXT = "COLOR:";
const ABOUT_TEXT = "About";
const PDP_CONFIG = {
  MAX_QTY: "You Can Add Max $sellableQuantity Quantity of This Item.",
  OOS_MESSAGE: "Sorry! This Product is Out Of Stock.",
  ADD_TO_BAG_SUCCESS: "We've added this product to your cart",
  ACCORDION_CONFIG: { DESKTOP_ACCORDION, ABOUT_TEXT, MOBILE_ACCORDION, COLOR_TEXT },
  PDP_DETAILS_BLOCK: {
    ADD_TO_BAG_STATE: "ADD TO CART",
    CHECKOUT_STATE: "CHECKOUT",
  },
  PRODUCT_RIGHT_PANEL: {
    ADD_TO_BAG_BUTTON: "ADD TO CART",
  },
};

export { SOLID_COLOR_SET, PDP_CONFIG };
